import { Theme, Typography } from '@mui/material';
import { FC, ReactNode, CSSProperties } from 'react';
import { makeStyles } from 'tss-react/mui';

const Section: FC<React.PropsWithChildren<SectionProps>> = ({
  label,
  labelIcon,
  children,
  style,
  className,
}) => {
  const { classes, cx } = useStyles();

  if (!children) {
    return null;
  }

  return (
    <div className={cx(classes.section, className)} style={style}>
      <Typography
        variant='body2'
        color='text.secondary'
        className={classes.header}>
        {label}
        {labelIcon}
      </Typography>

      {typeof children === 'string' && (
        <Typography
          variant='body1'
          color='text.primary'
          className={classes.contentText}>
          {children}
        </Typography>
      )}
      {typeof children !== 'string' && <>{children}</>}
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  section: {
    maxWidth: 300,
    minWidth: 200,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    letterSpacing: 0.8,
    lineHeight: '1em',
  },
  contentText: {
    wordBreak: 'break-all',
  },
  labelIconWrapper: {
    display: 'inline-flex',
  },
}));

export interface SectionProps {
  label: string;
  labelIcon?: ReactNode;
  style?: CSSProperties;
  className?: string;
}

export default Section;
